import React from 'react';
import { useMarketingName } from './use-marketing-name';

export { useMarketingName } from './use-marketing-name';

interface ModelDisplayProps {
  /** 硬件型号（如 'SM-S928B' 或 'iPhone15,4'），null/undefined 时显示 '-' */
  model: string | null | undefined;
}

/**
 * 机型展示组件
 *
 * 通过 GetMarketingNameByModel API 动态获取市场名称，统一展示为 「型号 (市场名称)」格式。
 * 型号加粗，市场名称灰色。未查询到市场名称时只显示型号。
 *
 * 使用示例：
 * ```tsx
 * <ModelDisplay model={info?.model} />
 * // 渲染为：SM-S928B (Samsung Galaxy S24 Ultra)  或无括号版：SM-S928B
 * ```
 */
export const ModelDisplay: React.FC<ModelDisplayProps> = (props) => {
  const { model } = props;
  const { displayLabel } = useMarketingName(model);

  return <>{displayLabel}</>;
};
